import type { InjectionKey } from 'vue'
import type { Transport } from '@connectrpc/connect'

export const transportKey: InjectionKey<Transport> = Symbol('portal.transport')
